import { render } from "./Dividend_Rates.vue?vue&type=template&id=2d3a8c55"
import script from "./Dividend_Rates.vue?vue&type=script&lang=js"
export * from "./Dividend_Rates.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__